<template>
	<a
		class="site_button_secondary"
		:class="theme"
		:href="parsedLink.url ? parsedLink.url : button_link"
		:target="parsedLink.target ? parsedLink.target : ((type === 'download' || target === '_blank') ? '_blank' : button_link.target)"
		@mouseenter="hovered = true"
		@mouseleave="hovered = false"
		ref="site_button_secondary"
	>
		<span
			v-if="type != 'citb_download'"
			v-html="button_label ? (type === 'download' ? 'Download' : button_label) :  (type === 'download' ? 'Download' : parsedLink.title)"
			:class="arrow_color"
		></span>

		<span
			v-else
			v-html="button_label ? (type === 'download' ? 'Download' : button_label) :  (type === 'download' ? 'Download' : parsedLink.title)"
			:class="arrow_color"
		></span>

		<div
			class="download_container"
			v-if="type === 'download' || type === 'citb_download'"
		>
			<svg
				id="Download-icon"
				xmlns="http://www.w3.org/2000/svg"
				width="17.655"
				height="16.75"
				viewBox="0 0 17.655 16.75"
			>
				<line
					id="Line_60"
					data-name="Line 60"
					x1="17.655"
					transform="translate(0 16)"
					fill="none"
					stroke="#232350"
					stroke-width="1.5"
				/>
				<g
					id="Group_677"
					data-name="Group 677"
					transform="translate(2.659)"
				>
					<path
						id="Arrow-basic"
						d="M8.828,0V8.828H0"
						transform="translate(6.242 0.274) rotate(45)"
						fill="none"
						stroke="#232350"
						stroke-width="1.5"
					/>
					<line
						id="Line_59"
						data-name="Line 59"
						y2="12.69"
						transform="translate(6.168)"
						fill="none"
						stroke="#232350"
						stroke-width="1.5"
					/>
				</g>
			</svg>
		</div>

		<svg
			v-if="theme === 'not_found_cta'"
			class="not_found_cta"
			width="25"
			height="16"
			viewBox="0 0 25 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M14.7936 1.41421L21.3732 7.99384L14.7936 14.5735L16.2078 15.9877L24.2017 7.99384L16.2078 0L14.7936 1.41421ZM17 6.99384H0V8.99384H17V6.99384Z"
				fill="black"
			/>
		</svg>

		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="15.811"
			height="15.811"
			viewBox="0 0 15.811 15.811"
			class="external_link_icon"
			v-if="parsedLink.target === '_blank' || button_link.target === '_blank' || target === '_blank'"
		>
			<g
				id="External-Link-Icon"
				transform="translate(0.75 1.061)"
			>
				<path
					id="Path_276"
					data-name="Path 276"
					d="M16.167,14.444v4.667a1.556,1.556,0,0,1-1.556,1.556H6.056A1.556,1.556,0,0,1,4.5,19.111V10.556A1.556,1.556,0,0,1,6.056,9h4.667"
					transform="translate(-4.5 -6.667)"
					fill="none"
					stroke="#232350"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
				<path
					id="Path_277"
					data-name="Path 277"
					d="M22.5,4.5h4.667V9.167"
					transform="translate(-13.167 -4.5)"
					fill="none"
					stroke="#232350"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
				<path
					id="Path_278"
					data-name="Path 278"
					d="M15,13.056,23.556,4.5"
					transform="translate(-9.556 -4.5)"
					fill="none"
					stroke="#232350"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="1.5"
				/>
			</g>
		</svg>

	</a>
</template>

<script>
export default {
	data() {
		return {
			button_label: this.label,
			button_link: this.link,
			hovered: false,
		};
	},

	props: {
		link: {},
		label: {},
		label_color: {
			default: 'white',
		},
		arrow_color: {
			default: 'white',
		},
		theme: {
			default: 'light',
		},
		type: {},
		target: {
			default: '_self',
		},
	},

	computed: {
		parsedLink() {
			if (typeof this.link === 'object' && this.link !== null) {
				return this.link;
			} else if (!Array.isArray(this.link)) {
				return this.button_link;
			} else {
				return JSON.parse(this.link);
			}
		},
	},

	watch: {
		link() {
			this.button_link = this.link;
		},
	},

	methods: {
		checkEmpty(e) {
			if (this.button_link.url === '#') {
				// this.$refs.site_button_secondary.removeAttribute('href');
				e.preventDefault();
			}
		},
	},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.site_button_secondary {
	display: inline-flex;
	padding: 12px 24px 10px;
	transition: 0.2s ease all;
	text-decoration: none;
	justify-content: flex-start;
	position: relative;
	border-radius: 32px;
	background: transparent;
	align-items: center;
	transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
		border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
	transform: perspective(1px) translateZ(0);
	transition-property: color;
	transition-duration: 0.3s;
	overflow: hidden;
	text-decoration: none;

	.download_container {
		display: flex;
		justify-content: center;
		align-items: center;

		svg {
			margin-left: 8px;

			line,
			path {
				stroke: var(--midnight-navy) !important;

				g {
					stroke: var(--midnight-navy);
				}
			}
		}
	}

	.external_link_icon {
		margin-left: 8px;

		line,
		path {
			stroke: var(--midnight-navy) !important;
			transition: 0.2s ease all;

			g {
				stroke: var(--midnight-navy);
				transition: 0.2s ease all;
			}
		}
	}

	&.light {
		border: 1px solid var(--midnight-navy);
		background: transparent;

		span {
			color: var(--midnight-navy);
		}

		&:before {
			content: '';
			position: absolute;
			z-index: -1;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: var(--midnight-navy);
			transform: scaleX(0);
			transform-origin: 0 50%;
			transition-property: transform;
			transition-duration: 0.3s;
			transition-timing-function: ease-out;
		}

		@media (hover) {
			&:hover {
				/* border: 1px solid var(--midnight-navy); */

				span {
					color: white;
				}

				.external_link_icon {
					line,
					path {
						stroke: white !important;

						g {
							stroke: white;
						}
					}
				}

				.download_container {
					svg {
						line,
						path {
							stroke: white !important;
							transition: 0.2s ease all;

							g {
								stroke: white;
								transition: 0.2s ease all;
							}
						}
					}
				}
			}
		}
	}

	&.dark {
		border: 1px solid var(--yellow);
		background: var(--midnight-navy);

		span {
			color: var(--yellow);
		}

		.download_container {
			svg {
				line,
				path {
					stroke: var(--yellow) !important;
					transition: 0.2s ease all;

					g {
						stroke: var(--yellow);
						transition: 0.2s ease all;
					}
				}
			}
		}

		&:before {
			content: '';
			position: absolute;
			z-index: -1;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: var(--yellow);
			transform: scaleX(0);
			transform-origin: 0 50%;
			transition-property: transform;
			transition-duration: 0.3s;
			transition-timing-function: ease-out;
		}

		@media (hover) {
			&:hover {
				border: 1px solid var(--midnight-navy);

				span {
					color: var(--midnight-navy);
				}
			}
		}
	}

	&.funding {
		border: 1px solid var(--midnight-navy);
		background: var(--midnight-navy);

		span {
			color: white;
		}

		.download_container {
			svg {
				line,
				path {
					stroke: white !important;
					transition: 0.2s ease all;

					g {
						stroke: white;
						transition: 0.2s ease all;
					}
				}
			}
		}

		&:before {
			content: '';
			position: absolute;
			z-index: -1;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: white;
			transform: scaleX(0);
			transform-origin: 0 50%;
			transition-property: transform;
			transition-duration: 0.3s;
			transition-timing-function: ease-out;
		}

		@media (hover) {
			&:hover {
				border: 1px solid var(--midnight-navy);

				span {
					color: var(--midnight-navy);
				}
			}
		}
	}

	&.reverse {
		border: 1px solid white;
		background: transparent;

		span {
			color: white;
		}

		.download_container {
			svg {
				line,
				path {
					stroke: white !important;
					transition: 0.2s ease all;

					g {
						stroke: white;
						transition: 0.2s ease all;
					}
				}
			}
		}

		&:before {
			content: '';
			position: absolute;
			z-index: -1;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: white;
			transform: scaleX(0);
			transform-origin: 0 50%;
			transition-property: transform;
			transition-duration: 0.3s;
			transition-timing-function: ease-out;
		}

		@media (hover) {
			&:hover {
				/* border: 1px solid var(--midnight-navy); */

				span {
					color: var(--midnight-navy);
				}

				.download_container {
					svg {
						line,
						path {
							stroke: var(--midnight-navy) !important;
							transition: 0.2s ease all;

							g {
								stroke: var(--midnight-navy);
								transition: 0.2s ease all;
							}
						}
					}
				}
			}
		}
	}

	&.not_found_cta {
		border: 1px solid white;
		background: var(--midnight-navy);

		span {
			color: white;
		}

		&:before {
			content: '';
			position: absolute;
			z-index: -1;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: var(--yellow);
			transform: scaleX(0);
			transform-origin: 0 50%;
			transition-property: transform;
			transition-duration: 0.3s;
			transition-timing-function: ease-out;
		}

		svg {
			margin-left: 10px;

			path {
				fill: var(--yellow);
				transition: fill 0.2s ease;
			}
		}

		@media (hover) {
			&:hover {
				border: 1px solid var(--yellow);

				span {
					color: var(--midnight-navy);
				}

				svg {
					path {
						fill: var(--midnight-navy);
						transition: fill 0.2s ease;
					}
				}
			}
		}
	}

	@media (hover) {
		&:hover {
			transition: 0.2s ease all;
			cursor: pointer;

			span {
				transition: 0.2s ease all;
			}

			&:before {
				transform: scaleX(1);
			}
		}
	}

	&:disabled {
		opacity: 0.5;
	}

	span {
		font: normal normal bold 14px/20px var(--primary-font-family);
		text-transform: uppercase;
		transition: 0.2s ease all;
		margin-right: 0;
		position: relative;
		z-index: 10;
	}

	img {
		display: flex;
		max-width: 24px;
		max-height: 12px;
		margin-left: 8px;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SecondaryButton.vue